import type { AccountDataScope } from "./AccountDataScope";
import { STANDALONE_PRODUCT_SLOTS } from "../standalone/app/standaloneProductSlots";

/** 待支付订单支付时限（毫秒） */
export const STORE_ORDER_PAY_DEADLINE_MS = 30 * 60 * 1000;

export function isStoreOrderPaid(row: { displayStatus?: string | null } | null | undefined): boolean {
  const s = row?.displayStatus?.trim();
  return s != null && s !== "unpaid" && s !== "cancelled";
}

export function isStoreOrderUnpaid(row: { displayStatus?: string | null } | null | undefined): boolean {
  return row?.displayStatus === "unpaid";
}

export function parseStoreOrderCreatedAtMs(raw: unknown): number | null {
  if (raw == null || raw === "") return null;
  if (raw instanceof Date) {
    const t = raw.getTime();
    return Number.isNaN(t) ? null : t;
  }
  if (typeof raw === "string") {
    const s = raw.trim();
    if (!s) return null;
    const iso = s.includes("T") ? s : s.replace(" ", "T");
    const t = new Date(iso).getTime();
    return Number.isNaN(t) ? null : t;
  }
  return null;
}

export function formatPayCountdown(remainingMs: number): string {
  const sec = Math.max(0, Math.floor(remainingMs / 1000));
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}

export function resolveStoreOrderServicePath(
  order: {
    spaceId: string;
    spaceProductId?: string | null;
    productType?: string | null;
  },
  scope: AccountDataScope
): string {
  if (scope === "standalone") {
    const kind = (order.productType ?? "").trim();
    const slot = STANDALONE_PRODUCT_SLOTS.find((s) => s.productKind === kind);
    return slot ? `/tactik/${slot.routePath}` : "/tactik";
  }
  const sid = order.spaceId.trim();
  const pid = order.spaceProductId?.trim();
  if (pid) {
    return `/space/${encodeURIComponent(sid)}/${encodeURIComponent(pid)}`;
  }
  return `/space/${encodeURIComponent(sid)}/home`;
}

export function resolveStoreOrderListPath(scope: AccountDataScope): string {
  if (scope === "standalone") {
    return "/tactik/orders";
  }
  return "/orders";
}

export function resolveStoreOrderDetailPath(
  order: { spaceId: string; orderId: string },
  scope: AccountDataScope
): string {
  if (scope === "standalone") {
    return `/tactik/orders/${encodeURIComponent(order.orderId)}`;
  }
  return `/orders/${encodeURIComponent(order.spaceId)}/${encodeURIComponent(order.orderId)}`;
}

export function resolveStoreCheckoutPath(
  order: { spaceId: string; orderId: string },
  scope: AccountDataScope
): string {
  if (scope === "standalone") {
    return `/tactik/checkout/${encodeURIComponent(order.orderId)}`;
  }
  return `/checkout/${encodeURIComponent(order.spaceId)}/${encodeURIComponent(order.orderId)}`;
}
